export const common = {
  loading: "جارٍ التحميل…",
  tryAgain: "حاول مرة أخرى",
  requestId: "معرّف الطلب: {id}",
  closeDialog: "إغلاق النافذة",
  notifications: "الإشعارات",
  cancel: "إلغاء",
  save: "حفظ",
  close: "إغلاق",
  add: "إضافة",
  remove: "إزالة",
  delete: "حذف",
  edit: "تعديل",
  search: "بحث",
  filter: "تصفية",
  all: "الكل",
  none: "لا شيء",
  yes: "نعم",
  no: "لا",
  status: "الحالة",
  actions: "إجراءات",
  created: "تاريخ الإنشاء",
  updated: "آخر تحديث",
  notes: "ملاحظات",
  optional: "اختياري",
  loadingState: "جارٍ التحميل",
  empty: "لا توجد سجلات",
  errorRetry: "حدث خطأ ما.",
  signOut: "تسجيل الخروج",
  brandName: "Grizzly Shop",
  brandSubtitle: "عمليات الصناعات",
  skipToContent: "تخطَّ إلى المحتوى الرئيسي",
  openMenu: "فتح القائمة",
  closeMenu: "إغلاق القائمة",
  switchLanguage: "تبديل اللغة",
  creating: "جارٍ الإنشاء…",
  saving: "جارٍ الحفظ…",
  done: "تم",
  primaryContact: "جهة الاتصال الأساسية",
  primary: "أساسي",
  unassigned: "غير معيّن",
  fields: {
    name: "الاسم",
    title: "المسمى الوظيفي",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    notes: "ملاحظات",
    label: "التسمية",
    kind: "النوع",
    city: "المدينة",
    region: "المنطقة",
    postalCode: "الرمز البريدي",
    country: "الدولة",
    street: "الشارع",
    line2: "السطر الثاني",
    dueDate: "تاريخ الاستحقاق",
    priority: "الأولوية",
    subject: "الموضوع",
    assignTo: "الإسناد إلى",
    type: "النوع",
    description: "الوصف",
    quantity: "الكمية",
    unit: "الوحدة",
    unitPrice: "سعر الوحدة",
    amount: "المبلغ",
    date: "التاريخ",
    reason: "السبب",
    method: "الطريقة",
    reference: "المرجع",
    category: "الفئة",
    customer: "العميل",
    invoice: "الفاتورة",
    status: "الحالة",
    search: "بحث",
    from: "من",
    to: "إلى",
    code: "الرمز",
    sku: "SKU",
    rate: "المعدل",
    sequence: "التسلسل",
    workCenter: "مركز العمل",
    setupMinutes: "دقائق التجهيز",
    runMinutes: "دقائق التشغيل للوحدة",
    material: "المادة",
    plannedQuantity: "الكمية المخططة",
    total: "الإجمالي",
    balance: "الرصيد",
    paid: "المدفوع",
    due: "الاستحقاق",
    count: "العدد",
  },
  when: "متى",
  notFound: {
    title: "الصفحة غير موجودة",
    description: "العنوان الذي تبعته غير موجود في نظام الورشة.",
    back: "العودة إلى لوحة التحكم",
  },
  placeholder: {
    plannedFor: "مخطّط لشريحة {slice}.",
    coming: "قادم في {slice}",
  },
};
